import React, { useState, useEffect } from 'react';
import { LuChevronRight, LuChevronDown } from "react-icons/lu"; 
import "../../asset/css/register.css";
import { baseurl } from '../../baseurl';
import axios from 'axios';
import Swal from 'sweetalert2';
import logo from "../../asset/img/white.png";

const Terms = () => {
   
  return (
    <div className="register-wrapper">
      <nav className="reg-nav">
        <div className="reg-logo">
          <div>
      <img src={logo} className='img-fluid' style={{maxHeight:"40px",}} />
    {/* <div className="sub-brand  text-dark">Project Management Dashboard</div> */}
    </div>
        </div>
        <div className="login-link">
          Already have an account? <a href="/login">Log in</a>
        </div>
      </nav>











 <section class="page-content">
    <div class="container">
      <span class="last-updated"><i class="far fa-calendar-alt" style={{marginRight: "6px"}}></i> Last Updated: May 1, 2026</span>

      <h1><i class="fas fa-file-contract"></i> Terms of Service</h1>
      <p class="intro">
        These Terms of Service ("Terms") govern your use of Measro's GIS property measurement platform. By using Measro, you agree to these Terms. We're committed to transparency and fair play — read on to understand your rights and responsibilities.
      </p>

     
      <h2><i class="fas fa-info-circle"></i> 1. About Measro</h2>
      <p>Measro provides automated GIS-based property measurement services using Nearmap aerial imagery and geographic information system technology. We serve landscaping, snow management, pavement, and facility management professionals across the United States and Canada.</p>

     
      <h2><i class="fas fa-user-check"></i> 2. Eligibility</h2>
      <p>You must be at least 18 years old and have the legal authority to enter into these Terms on behalf of yourself or your company. By using Measro, you represent that you meet these requirements.</p>

   
      <h2><i class="fas fa-user-plus"></i> 3. Account Registration</h2>
      <p>To access certain features, you may need to create an account. You are responsible for:</p>
      <ul>
        <li>Providing accurate and complete registration information</li>
        <li>Keeping your login credentials confidential and secure</li>
        <li>All activities that occur under your account</li>
        <li>Notifying us immediately of any unauthorized access</li>
      </ul>

    
      <h2><i class="fas fa-ruler-combined"></i> 4. Services &amp; Deliverables</h2>
      <p>Measro delivers property measurement reports based on Nearmap aerial imagery and GIS analysis. While we strive for 6-inch accuracy, measurements are estimates based on available imagery and data. Factors such as imagery resolution, vegetation cover, and property conditions may affect precision.</p>

      <div class="highlight-box">
        <p><i class="fas fa-info-circle"></i> Measurement reports are intended for estimation and planning purposes. Always verify critical measurements on-site before finalizing bids or purchases.</p>
      </div>

 
      <h2><i class="fas fa-credit-card"></i> 5. Payment &amp; Billing</h2>
      <p>Fees for Measro services are clearly displayed before purchase. Payment is processed securely through our third-party payment processor. You agree to pay all charges associated with your account. All fees are in USD and are non-refundable unless otherwise stated.</p>

   
      <h2><i class="fas fa-copyright"></i> 6. Intellectual Property</h2>
      <p>Measro's platform, technology, algorithms, branding, and content are owned by Measro Inc. and protected by intellectual property laws. Measurement data and reports generated for you remain your property. You may not copy, reverse-engineer, or resell Measro's technology or platform.</p>

    
      <h2><i class="fas fa-check-circle"></i> 7. Acceptable Use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use Measro for any unlawful purpose</li>
        <li>Submit false, misleading, or fraudulent property information</li>
        <li>Attempt to access other users' accounts or data</li>
        <li>Interfere with the platform's operation or security</li>
        <li>Resell or redistribute measurement reports without authorization</li>
      </ul>

    
      <h2><i class="fas fa-gavel"></i> 8. Limitation of Liability</h2>
      <p>Measro is provided "as is" without warranties of any kind. To the maximum extent permitted by law, Measro Inc. shall not be liable for any indirect, incidental, or consequential damages arising from your use of our services. Our total liability is limited to the amount you paid for the specific service giving rise to the claim.</p>

     
      <h2><i class="fas fa-ban"></i> 9. Termination</h2>
      <p>We may suspend or terminate your account if you violate these Terms. You may discontinue using Measro at any time. Upon termination, your right to access the platform ceases, but measurement reports you've already received remain yours.</p>

     
      <h2><i class="fas fa-balance-scale"></i> 10. Governing Law</h2>
      <p>These Terms are governed by the laws of the State of Wyoming, USA. For users in Canada, applicable Canadian federal and provincial laws also apply. Any disputes shall be resolved through binding arbitration in Sheridan, Wyoming.</p>

    
      <h2><i class="fas fa-pen-fancy"></i> 11. Changes to Terms</h2>
      <p>We may update these Terms from time to time. Material changes will be communicated via email or platform notice. Your continued use after changes take effect constitutes acceptance of the updated Terms.</p>

 
      <h2><i class="fas fa-envelope"></i> 12. Contact</h2>
      <p>Questions about these Terms? Reach out to us — we're here to help.</p>

      <div class="contact-block">
        <ul>
          <li><strong>Email:</strong> <a href="mailto:support@measro.com">support@measro.com</a></li>
          <li><strong>Address:</strong> Measro LLC., 30 N Gould St Ste R, Sheridan, WY 82801</li>
        </ul>
      </div>

     
      <div style={{marginTop: "36px", paddingTop: "24px", borderTop: "1px solid var(--border)"}}>
        <p style={{fontSize: "14px", color: "var(--text-lighter);"}}>
          <i class="fas fa-info-circle" style={{color: "var(--primary)", marginRight: "6px;"}}></i>
          <strong>Measro’s commitment:</strong> We believe in clear, fair terms that protect both you and our platform. These Terms are designed to foster trust and ensure a smooth experience. If you have any questions, our team is ready to assist.
        </p>
      </div>

    </div>
  </section>

 
  <footer>
    <div class="container">
      <p>
        &copy; 2026 Measro LLC. All rights reserved.
        <span class="footer-divider">|</span>
        <a href="/privacy">Privacy Policy</a>
        <span class="footer-divider">|</span>
        <a href="/terms">Terms of Service</a>
      </p>
    </div>
  </footer>



 

<style>
    {`
     * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }

    :root {
      --primary: #4E46E4;
      --primary-dark: #4E46E4;
      --primary-light: #c77dff;
      --primary-bg: rgba(157, 78, 221, 0.07);
      --primary-gradient: linear-gradient(135deg, #6366f1  0%, #4f46e5 100%);
      --white: #ffffff;
      --text: #1a1a2e;
      --text-light: #555770;
      --text-lighter: #8e8ea0;
      --gray: #f7f7fc;
      --border: #e8e8f0;
      --shadow-sm: 0 2px 12px rgba(0, 0, 0, 0.04);
      --shadow-md: 0 8px 30px rgba(157, 78, 221, 0.10);
      --radius-xl: 20px;
      --radius-lg: 14px;
    }

    body {
      font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
      color: var(--text);
      line-height: 1.7;
      background: #fafaff;
      -webkit-font-smoothing: antialiased;
    }

    .container {
      width: 100%;
      max-width: 820px;
      margin: 0 auto;
      padding: 0 24px;
    }

    /* ----- HEADER (Measro theme) ----- */
    header {
      background: rgba(255, 255, 255, 0.92);
      backdrop-filter: blur(14px);
      -webkit-backdrop-filter: blur(14px);
      box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
      position: sticky;
      top: 0;
      z-index: 1000;
      border-bottom: 1px solid var(--border);
    }

    .header-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 14px 0;
    }

    .logo {
      display: flex;
      align-items: center;
      gap: 10px;
      text-decoration: none;
    }

    .logo-icon {
      width: 40px;
      height: 40px;
      background: var(--primary-gradient);
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 20px;
      box-shadow: 0 4px 12px rgba(157, 78, 221, 0.25);
    }

    .logo-text {
      font-size: 24px;
      font-weight: 800;
      color: var(--text);
      letter-spacing: -0.4px;
    }

    .logo-text span {
      background: var(--primary-gradient);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }

    .back-link {
      text-decoration: none;
      color: var(--text-light);
      font-weight: 500;
      font-size: 14px;
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 16px;
      border-radius: 40px;
      transition: all 0.2s ease;
      background: var(--gray);
    }

    .back-link i {
      font-size: 13px;
      transition: transform 0.2s ease;
    }

    .back-link:hover {
      background: var(--primary-bg);
      color: var(--primary);
    }

    .back-link:hover i {
      transform: translateX(-3px);
    }

    /* ----- PAGE CONTENT (Measro styled) ----- */
    .page-content {
      padding: 56px 0 72px;
    }

    .page-content .last-updated {
      display: inline-block;
      font-size: 12px;
      font-weight: 500;
      color: var(--text-lighter);
      background: var(--gray);
      padding: 6px 16px;
      border-radius: 40px;
      margin-bottom: 20px;
      letter-spacing: 0.3px;
      border: 1px solid var(--border);
    }

    .page-content h1 {
      font-size: 2.4rem;
      font-weight: 800;
      color: var(--text);
      margin-bottom: 10px;
      letter-spacing: -0.6px;
      line-height: 1.2;
    }

    .page-content h1 i {
      color: var(--primary);
      margin-right: 10px;
      font-size: 2rem;
    }

    .page-content .intro {
      color: var(--text-light);
      font-size: 1.05rem;
      margin-bottom: 40px;
      padding-bottom: 32px;
      border-bottom: 2px solid var(--border);
      line-height: 1.6;
    }

    .page-content h2 {
      font-size: 1.3rem;
      font-weight: 700;
      color: var(--text);
      margin-top: 40px;
      margin-bottom: 14px;
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .page-content h2 i {
      color: var(--primary);
      font-size: 1.1rem;
      width: 28px;
      text-align: center;
    }

    .page-content p {
      color: var(--text-light);
      font-size: 15px;
      margin-bottom: 18px;
      line-height: 1.7;
    }

    .page-content ul {
      list-style: none;
      margin-bottom: 20px;
      padding-left: 8px;
    }

    .page-content ul li {
      color: var(--text-light);
      font-size: 15px;
      margin-bottom: 10px;
      padding-left: 28px;
      position: relative;
      line-height: 1.6;
    }

    .page-content ul li::before {
      content: '◆';
      color: var(--primary);
      position: absolute;
      left: 2px;
      font-size: 12px;
      top: 2px;
    }

    .page-content ul li strong {
      color: var(--text);
      font-weight: 600;
    }

    .page-content a {
      color: var(--primary);
      text-decoration: none;
      font-weight: 500;
      border-bottom: 1px solid transparent;
      transition: border-color 0.2s;
    }

    .page-content a:hover {
      border-bottom-color: var(--primary);
      text-decoration: none;
    }

    /* Measro highlight box */
    .page-content .highlight-box {
      background: var(--primary-bg);
      border-radius: var(--radius-lg);
      padding: 22px 28px;
      margin: 32px 0 28px;
      border-left: 4px solid var(--primary);
      box-shadow: var(--shadow-sm);
    }

    .page-content .highlight-box p {
      margin-bottom: 0;
      font-weight: 500;
      color: var(--text);
      font-size: 15px;
      display: flex;
      align-items: flex-start;
      gap: 12px;
    }

    .page-content .highlight-box p i {
      color: var(--primary);
      font-size: 18px;
      margin-top: 2px;
    }

    /* contact block */
    .contact-block {
      background: var(--gray);
      border-radius: var(--radius-lg);
      padding: 24px 28px;
      margin-top: 24px;
      border: 1px solid var(--border);
    }

    .contact-block ul {
      margin-bottom: 0;
    }

    .contact-block ul li {
      padding-left: 28px;
    }

    .contact-block ul li::before {
      content: '▸';
      color: var(--primary);
      font-size: 14px;
    }

    /* footer */
    footer {
      text-align: center;
      padding: 28px 0 32px;
      color: var(--text-lighter);
      font-size: 13px;
      border-top: 1px solid var(--border);
      background: var(--white);
    }

    footer a {
      color: var(--primary);
      text-decoration: none;
      font-weight: 500;
      margin: 0 6px;
    }

    footer a:hover {
      text-decoration: underline;
    }

    footer .footer-divider {
      color: var(--border);
      margin: 0 6px;
    }

    /* responsive */
    @media (max-width: 640px) {
      .page-content h1 {
        font-size: 1.8rem;
      }
      .page-content {
        padding: 32px 0 48px;
      }
      .header-container {
        flex-wrap: wrap;
        gap: 10px;
      }
      .back-link {
        font-size: 13px;
        padding: 6px 14px;
      }
      .logo-text {
        font-size: 20px;
      }
      .logo-icon {
        width: 34px;
        height: 34px;
        font-size: 16px;
      }
      .page-content .highlight-box {
        padding: 18px 20px;
      }
      .contact-block {
        padding: 18px 20px;
      }
    }

    @media (max-width: 400px) {
      .container {
        padding: 0 16px;
      }
      .page-content h1 {
        font-size: 1.5rem;
      }
      .page-content h2 {
        font-size: 1.1rem;
      }
    }

    `}
</style>

    </div>
  );
};

export default Terms;